$(document).ready(function() {

	$(".side-list-menu ul>li>span").on("click", function() {

		// only one tab will be open
		// if ($(".side-list-menu>ul>li.active-item")) {
		// 	$(".side-list-menu>ul>li").removeClass('active-item');
		// }


		// can be open many tabs 
		$(this).parent().toggleClass('active-item');
	});

	$(".drop-list>li").on("click", function() {
		$(".drop-list>li").removeClass('active-item');
		$(this).toggleClass('active-item');
	});


	// Add active-red class for side-nav in content-page	
	$(".side-list-menu-closed>ul>li").on("click", function() {
		$(".side-list-menu-closed>ul>li").removeClass('active-red');
		$(this).toggleClass('active-red');
	});

});